<template lang="html">
  <div class="row">
    <div class="col-sm-12 text-center">
      <h3>{{translation.statistic.title}}</h3>
    </div>
    <div class="col-sm-12">
      <canvas id="lineChart"></canvas>
    </div>
    <div class="col-sm-12">
      <div class="text-center">
        <h3>{{translation.statistic.yearStatistic}}</h3>
      </div>
      <canvas id="barChart"></canvas>
    </div>
  </div>
</template>

<script>
import { mdbLineChart } from 'mdbvue';
export default {
  name: 'DoctorStatistic',
  data(){
    return {
      translation: null,
      usersMonthsCounts: null,
      petsMonthsCounts: null,
      paymentsMonthsCounts: null,
      yearCounts: null
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.loader = true;
    var self = this;
    axios.get('get-doctor-statistic')
    .then(function (response){
        self.loader = false;
        self.usersMonthsCounts = response.data.result.usersMonthsCounts;
        self.petsMonthsCounts = response.data.result.petsMonthsCounts;
        self.paymentsMonthsCounts = response.data.result.paymentsMonthsCounts;
        self.yearCounts = response.data.result.countsByYear;
    })
    .catch(err => console.error(err))
  },
  watch:{
    usersMonthsCounts: function(){
      if (this.usersMonthsCounts) {
            //line
            var ctxL = document.getElementById("lineChart").getContext('2d');
            var myLineChart = new Chart(ctxL, {
            type: 'line',
            data: {
            labels: this.translation.statistic.months,
            datasets: [{
            label: this.translation.statistic.pets,
            data: this.petsMonthsCounts,
            backgroundColor: [
            'rgba(105, 0, 132, .2)',
            ],
            borderColor: [
            'rgba(200, 99, 132, .7)',
            ],
            borderWidth: 2
            },
            {
            label: this.translation.statistic.users,
            data: this.usersMonthsCounts,
            backgroundColor: [
            'rgba(0, 137, 132, .2)',
            ],
            borderColor: [
            'rgba(48, 87, 176, .7)',
            ],
            borderWidth: 2
            },
            {
            label: this.translation.statistic.pay,
            data: this.paymentsMonthsCounts,
            backgroundColor: [
            'rgba(100, 151, 40, .2)',
            ],
            borderColor: [
            'rgba(100, 151, 40, .7)',
            ],
            borderWidth: 2
            }
            ]
            },
            options: {
            responsive: true
            }
            });
            //bar
            var ctxB = document.getElementById("barChart").getContext('2d');
            var myBarChart = new Chart(ctxB, {
            type: 'bar',
            data: {
            labels: [this.translation.statistic.pets,this.translation.statistic.users,this.translation.statistic.pay],
            datasets: [{
            label: '',
            data: this.yearCounts,
            backgroundColor: [
              'rgba(105, 0, 132, .2)',
              'rgba(0, 137, 132, .2)',
              'rgba(100, 151, 40, .2)'
            ],
            borderColor: [
              'rgba(200, 99, 132, .7)',
              'rgba(48, 87, 176, .7)',
              'rgba(100, 151, 40, .7)'
            ],
            borderWidth: 1
            }]
            },
            options: {
                legend: {
                  display: false
                },
                scales: {
                yAxes: [{
                ticks: {
                beginAtZero: true
                }
                }]
                }
              }
            });
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
